
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkCalculationitemTypeEnum } from '../models/work-calculationitem-type-enum';

export function getUpdateCalculationitemDtoFormGroup() {
return new FormGroup({
    calculationId: new FormControl<number | undefined>(undefined),
    calculationitemsGroupId: new FormControl<number | undefined>(undefined),
    itemId: new FormControl<number | undefined>(undefined),
    itemDescription: new FormControl<string | undefined>('', [Validators.maxLength(1000)]),
    notes: new FormControl<string | undefined>(''),
    stocklocationId: new FormControl<number | undefined>(undefined),
    sortableRank: new FormControl<number | undefined>(undefined),
    type: new FormControl<WorkCalculationitemTypeEnum | undefined>(undefined),
    discountPercentage: new FormControl<number | undefined>(undefined),
    optional: new FormControl<boolean | undefined>(false),
    additional: new FormControl<boolean | undefined>(false),
    missingAtImplementation: new FormControl<boolean | undefined>(false),
    visibleForCustomer: new FormControl<boolean | undefined>(false),
    targetAmount: new FormControl<number | undefined>(undefined),
    unitId: new FormControl<number | undefined>(undefined),
    purchaseChf: new FormControl<number | undefined>(undefined),
    saleChf: new FormControl<number | undefined>(undefined),
    saleChfExcl: new FormControl<number | undefined>(undefined),
    materialSalePrice: new FormControl<number | undefined>(undefined),
    workSalePrice: new FormControl<number | undefined>(undefined),
})
;
}
      